import React, { useState } from 'react';
import { Button, Box, Backdrop, TextField } from '@mui/material'
import AppLoader from '../../../components/AppLoader/AppLoader';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import SearchIcon from '@mui/icons-material/Search';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import '../OrganizationManagement.scss'
import '../OrgEntityDetailsDialog.scss'
import { useNavigate } from 'react-router-dom';
import { cfpBaseUrl } from '../../../network/urls';
import CheckPermissions from '../../../authorization/authorization';
import AdminCompanySelect from '../../../components/AdminCompanySelect/AdminCompanySelect';
import { tableStyle } from '../../../style/common';
import { companyShortName, convertDatewithTime } from '../../../services/Functions';
import BasicTable from '../../../components/basicTable/basicTable';
import useAdminOrgCompanyFilter, {
    filterOrgRowsByCompany,
} from '../hooks/useAdminOrgCompanyFilter';
import { useSelector } from 'react-redux';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Snackbar, Alert } from '@mui/material';
import Error from '../../../components/error/error';

const displayValue = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
};

const formatDetailDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined || dateValue === '') return '-';
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime()) || date.getFullYear() < 1971) return '-';
    return convertDatewithTime(dateValue);
};

const isSubDivisionActive = (status) => status === '0' || status === 'active';

const isSubDivisionStore = (isStore) => !(isStore === '0' || isStore === 'No');

const DetailField = ({ label, value }) => {
    const text = displayValue(value);
    return (
        <div className="org-details-dialog__field">
            <span className="org-details-dialog__label">{label}</span>
            <p className={`org-details-dialog__value${text === '-' ? ' org-details-dialog__value--muted' : ''}`}>
                {text}
            </p>
        </div>
    );
};

const DetailSection = ({ title, children }) => (
    <section className="org-details-dialog__section">
        <div className="org-details-dialog__section-header">
            <span className="org-details-dialog__section-accent" />
            <h4>{title}</h4>
        </div>
        <div className="org-details-dialog__grid">{children}</div>
    </section>
);

export default function SubDivisionManagementTable(props) {
    //#region 
    const [subDivisionToDataGrid, setSubDivisionToDataGrid] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltSubDivision, setDltSubDivision] = useState()
    const [tableSubDivision, setTableSubDivision] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(true);
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [apiError, setApiError] = useState('')
    const Navigate = useNavigate();

    const errorCloses = () => {
        setApiError("")
    };
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)
    const {
        isAdminUser,
        selectedCompanyCode,
        handleChangeCompany,
        getHierarchyApiScopeCode,
    } = useAdminOrgCompanyFilter();

    //#endregion
    useEffect(() => {
        if (!tableDataLoaded) return;
        apiToDataGridConversion();
        setViewBackdrop(false);
    }, [tableSubDivision, tableDataLoaded]);

    useEffect(() => {
        const callAllSubDivisionsAPI = async () => {
            setViewBackdrop(true);
            setTableDataLoaded(false);

            if (isAdminUser && !selectedCompanyCode) {
                setTableSubDivision([]);
                setTableDataLoaded(true);
                return;
            }

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                divisionCode: isAdminUser
                    ? getHierarchyApiScopeCode()
                    : parseInt(userOfficeCode.toString().slice(0, 4)),
                pageNumber: 1,
                pageSize: 9999,
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/getSubDivisionDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        const rows = filterOrgRowsByCompany(
                            result.data,
                            isAdminUser,
                            selectedCompanyCode,
                            "subDivisionCode",
                        );
                        setTableSubDivision(rows);
                    } else if (result.status === "401" && result.message === "Session has been expired, Sign in again.") {
                        Navigate('/')
                        setTableSubDivision([]);
                    } else {
                        setTableSubDivision([]);
                    }
                })
                .catch(() => {
                    setTableSubDivision([]);
                });
            setTableDataLoaded(true);
        }
        callAllSubDivisionsAPI()
    }, [selectedCompanyCode, userOfficeCode, isAdminUser])

    const initialValues = {
        iv_subDivBankName: '',
        iv_subDivisionERPCode: '',
        iv_subDivCapitalCostAccountNo: '',
        iv_subDivSecurityAccountNo: '',
        iv_remarks: '',
    }
    const bankdetailsFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_subDivBankName: Yup.string()
                .max(100, 'Bank name cannot exceed 100 characters.')
                .min(10, 'Bank name must be at least 10 characters long.')
                .required('Bank name is required.'),

            iv_subDivisionERPCode: Yup.string()
                .required('ERP code is required.'),

            iv_subDivCapitalCostAccountNo: Yup.string()
                .min(10, 'Capital cost account no. must be at least 10 characters long.')
                .required('Capital cost account no. is required.'),

            iv_subDivSecurityAccountNo: Yup.string()
                .min(10, 'Security account no. must be at least 10 characters long.')
                .required('Security account no. is required.'),

            iv_remarks: Yup.string()
                .max(100, 'Remarks cannot exceed 100 characters.')
                .required('Remarks are required.')
        }),

        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "subDivisionCode": selectedUserId,
                "subDivisionERPCode": values.iv_subDivisionERPCode,
                "subDivBankName": values.iv_subDivBankName,
                "subDivCapitalCostAccountNo": values.iv_subDivCapitalCostAccountNo,
                "subDivSecurityAccountNo": values.iv_subDivSecurityAccountNo,
                "remarks": values.iv_remarks
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/updateSubDivisionBankDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        resetForm();
                        setShowChangePasswordPopup(false)
                        setShowSuccessSnackbar(true);
                        window.location.reload()
                        setTimeout(() => {
                            setShowChangePasswordPopup(false);
                        }, 300);
                    } else if (result.status === "400") {
                        setApiError(result.message)
                    }
                }
                )
                .catch(() => {});
            setViewBackdrop(false);
        },
    });
    const filterSubDivision = (subDivisionCode) => {
        let itemFound = tableSubDivision.find(item => item.subDivisionCode === subDivisionCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const closeBankDetailsPopup = () => {
        setShowChangePasswordPopup(false);
        setSelectedUserId(null);
        setApiError('');
        bankdetailsFormik.resetForm();
    };

    const onDelete = async () => {
        setViewBackdrop(true)
        var formdata = new FormData();
        formdata.append("subDivisionCode", dltSubDivision);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteSubDivision", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableSubDivision]
                    let index = myArray.findIndex(obj => obj.subDivisionCode === dltSubDivision);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableSubDivision(myArray)
                    }
                }
                else {
                }
            })
            .catch(() => {});
        handleClose2();
        setViewBackdrop(false)
    }
    const tblColumns = [
        { field: "id", headerName: 'Code', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'SubDivision Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "companyname", headerName: 'Company Name', headerAlign: 'left', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        CheckPermissions(permissions, "Organization Management", "Sub Division Management", "Update Sub Div Bank Details") && {
            field: "button",
            headerName: "Bank Details",
            headerAlign: "center",
            align: "center",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <IconButton aria-label="edit" size="small" sx={{ margin: 0.4, padding: 0 }}>
                        <EditNoteIcon
                            sx={{ color: "#e25316ff" }}
                            onClick={() => {
                                setSelectedUserId(params.id);
                                bankdetailsFormik.setValues({
                                    iv_subDivisionERPCode: params ? params.erp_code || "" : "",
                                    iv_subDivBankName: params ? params.bank_name || "" : "",
                                    iv_subDivCapitalCostAccountNo: params ? params.capital_code || "" : "",
                                    iv_subDivSecurityAccountNo: params ? params.security_code || "" : "",
                                    iv_remarks: "",
                                });

                                setShowChangePasswordPopup(true);
                            }}
                            alt="Bank Details"
                            style={{ width: "24px", height: "24px" }}
                        />
                    </IconButton>
                </div>
            ),
        },
        {
            headerName: "Action",
            sortable: false,
            field: 'buttons',
            headerAlign: 'center',
            align: 'center',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {
                const onViewSubDivision = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const item = filterSubDivision(params.id);
                    setDialogRowData(item);
                    setOpen(true);

                };
                const onDeleteSubDivision = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setDltSubDivision(params.id)
                }
                const onEditSubDivision = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const subDivisionToEdit = filterSubDivision(params.id);
                    Navigate('/sub-division-management/update-sub-division', { state: { subDivisionToEdit } })
                }

                return (
                    <Box>
                        {CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Read') && (
                            <IconButton onClick={onViewSubDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Update') && (
                            <IconButton onClick={onEditSubDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Delete') && (
                            <IconButton onClick={onDeleteSubDivision} size="small" sx={{ margin: 0, padding: 0 }}>
                                <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                            </IconButton>
                        )}
                    </Box>
                );
            }
        }
    ].filter(Boolean); // 🚀 removes the `false`

    // const tblColumns = [
    //     { field: "id", headerName: 'Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "completename", headerName: 'SubDivision Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "companyname", headerName: 'Company Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     CheckPermissions(permissions, "Organization Management", "Sub Division Management", "Update Sub Div Bank Details") && {
    //         field: "button",
    //         headerName: "Bank Details",
    //         align: "center",
    //         headerStyle: tableStyle.headerStyle,
    //         headerCellStyle: tableStyle.headerCellStyle,
    //         rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {
    //             return (
    //                 <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
    //                     <IconButton
    //                         aria-label="edit"
    //                         size="small"
    //                         sx={{ margin: 0.4, padding: 0 }}
    //                     >
    //                         <EditNoteIcon
    //                             sx={{ color: "#e25316ff" }}
    //                             onClick={() => {
    //                                 setSelectedUserId(params.id);
    //                                 setShowChangePasswordPopup(true);
    //                             }}
    //                             alt="Bank Details"
    //                             style={{ width: "24px", height: "24px" }}
    //                         />
    //                     </IconButton>
    //                 </div>
    //             );
    //         },
    //     },
    //     {
    //         headerName: "Action",
    //         sortable: false,
    //         field: 'buttons',
    //         align: 'center',
    //         headerStyle: tableStyle.headerStyle,
    //         headerCellStyle: tableStyle.headerCellStyle,
    //         rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {
    //             const onViewSubDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const item = filterSubDivision(params.id);
    //                 setDialogRowData(item);
    //                 setOpen(true);

    //             };
    //             const onDeleteSubDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 setopen2(true);
    //                 setDltSubDivision(params.id)
    //             }
    //             const onEditSubDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const subDivisionToEdit = filterSubDivision(params.id);
    //                 Navigate('/sub-division-management/update-sub-division', { state: { subDivisionToEdit } })
    //             }
    //             return (
    //                 <>
    //                     <Box>
    //                         <Box>
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Read') ?
    //                                     <IconButton onClick={onViewSubDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Update') ?
    //                                     <IconButton onClick={onEditSubDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Delete') ?
    //                                     <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteSubDivision}>
    //                                         <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
    //                                     </IconButton> : null
    //                             }
    //                         </Box>
    //                     </Box>
    //                 </>
    //             )
    //         }
    //     }
    // ]

    const apiToDataGridConversion = () => {
        const myArray = tableSubDivision
        const tempArray = []
        if (myArray) {
            myArray.forEach((item) => {
                const slicedCircleCode = item.subDivisionCode.toString().slice(0, 2);

                const dataGridObject = {
                    "id": item.subDivisionCode,
                    "completename": item.subDivisionName ? item.subDivisionName : '-',
                    // "created_by": item.createdBy ? item.createdBy : '-',
                    // "created_at": item.createdDate ? convertDate(item.createdDate) : '-',
                    // "updated_by": item.updateBy ? item.updateBy : '-',
                    // "updated_at": item.updatedDate ? convertDate(item.updatedDate) : '-',
                    "companyname": companyShortName(slicedCircleCode),
                    // "circlecode": item.circleCode ,
                    // "divisioncode": item.divisionCode ? item.divisionCode : '_',
                    "bank_name": item.subDivBankName ? item.subDivBankName : '-',
                    "erp_code": item.subDivErpCode ? item.subDivErpCode : '-',
                    "capital_code": item.subDivCapitalCostAccountNo ? item.subDivCapitalCostAccountNo : '-',
                    "security_code": item.subDivSecurityAccountNo ? item.subDivSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": " ",
                "completename": " ",
                "created_by": " ",
                "created_at": " ",
                "updated_by": " ",
                "updated_at": " ",
            }
            tempArray.push(dataGridObject)
        }
        setSubDivisionToDataGrid(tempArray);
        setFilteredData(tempArray); // keep a filtered copy
    }
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchQuery(value);

        const filtered = subDivisionToDataGrid.filter((row) =>
            row.id.toString().toLowerCase().includes(value) ||
            row.companyname?.toLowerCase().includes(value) ||
            row.completename?.toLowerCase().includes(value)
        );

        setFilteredData(filtered);
    };

    return (

        <>
            <Box className='form-box org-management-list'>
                {/* <Box className='main-heading'>
                    <h2>
                        Sub Division Management
                    </h2>
                    <div className='btn2'>
                        {
                            CheckPermissions(permissions,'Organization Management', 'Sub Division Management', 'Create') &&
                            < Link to="/sub-division-management/new-sub-division">
                                <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} sx={{ textTransform: 'capitalize' }} >
                                    Create Sub Division
                                </Button>
                            </Link>
                        }
                    </div>
                </Box> */}
                <Box className="mgmt-page-header">
                    <div className="mgmt-page-header__leading">
                        <h3 className="page-title">Sub Division Management</h3>
                        {isAdminUser && (
                            <AdminCompanySelect
                                value={selectedCompanyCode}
                                onChange={handleChangeCompany}
                                minWidth={180}
                                includePitc={false}
                                restrictToEnabled={false}
                            />
                        )}
                    </div>

                    <div className="mgmt-table-search">
                        <span className="mgmt-table-search__badge" aria-hidden="true">
                            <SearchIcon className="mgmt-table-search__icon" />
                        </span>
                        <input
                            type="text"
                            className="mgmt-table-search__input"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder="Search by Code, SubDivision Name or Company Name"
                            maxLength={20}
                            aria-label="Search subdivisions"
                        />
                    </div>
                </Box>



                <Box className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                        }} />
                </Box>
            </Box>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                className="alert-popups org-details-dialog"
                aria-labelledby="subdivision-details-dialog-title"
            >
                <DialogTitle
                    id="subdivision-details-dialog-title"
                    component="div"
                    className="dialog-title"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <span className="org-details-dialog__title-text">Sub Division Details</span>
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        aria-label="Close sub division details"
                        className="org-details-dialog__close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <div className="org-details-dialog__body">
                        <div className="org-details-dialog__hero">
                            <div className="org-details-dialog__logo-wrap">
                                <div className="org-details-dialog__avatar" aria-hidden="true">
                                    {(dialogRowData.subDivisionName || 'S').toString().charAt(0).toUpperCase()}
                                </div>
                            </div>
                            <div className="org-details-dialog__hero-meta">
                                <h2 className="org-details-dialog__name">
                                    {displayValue(dialogRowData.subDivisionName)}
                                </h2>
                                <p className="org-details-dialog__code">
                                    Sub Division ID: <strong>{displayValue(dialogRowData.subDivisionCode)}</strong>
                                </p>
                                <div className="org-details-dialog__badges">
                                    <span
                                        className={`org-details-dialog__status org-details-dialog__status--${
                                            isSubDivisionActive(dialogRowData.status) ? 'active' : 'inactive'
                                        }`}
                                    >
                                        {isSubDivisionActive(dialogRowData.status) ? 'Active' : 'Inactive'}
                                    </span>
                                    <span className="org-details-dialog__status org-details-dialog__status--neutral">
                                        Store: {isSubDivisionStore(dialogRowData.isStore) ? 'Yes' : 'No'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <DetailSection title="General Information">
                            <DetailField label="Latitude" value={dialogRowData.latitude} />
                            <DetailField label="Longitude" value={dialogRowData.longitude} />
                            <DetailField label="Created By" value={dialogRowData.createdBy} />
                            <DetailField label="Created At" value={formatDetailDate(dialogRowData.createdDate)} />
                            <DetailField label="Last Updated By" value={dialogRowData.updateBy} />
                            <DetailField
                                label="Last Updated At"
                                value={formatDetailDate(dialogRowData.updatedDate)}
                            />
                        </DetailSection>

                        <DetailSection title="Contact Person 1">
                            <DetailField label="Name" value={dialogRowData.cp1Name} />
                            <DetailField label="Phone" value={dialogRowData.cp1phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp1Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp1Email} />
                        </DetailSection>

                        <DetailSection title="Contact Person 2">
                            <DetailField label="Name" value={dialogRowData.cp2Name} />
                            <DetailField label="Phone" value={dialogRowData.cp2phone} />
                            <DetailField label="Mobile" value={dialogRowData.cp2Mobile} />
                            <DetailField label="Email" value={dialogRowData.cp2Email} />
                        </DetailSection>

                        <DetailSection title="Bank Details">
                            <DetailField label="Bank Name" value={dialogRowData.subDivBankName} />
                            <DetailField label="ERP Code" value={dialogRowData.subDivErpCode} />
                            <DetailField
                                label="Capital Cost Account No."
                                value={dialogRowData.subDivCapitalCostAccountNo}
                            />
                            <DetailField
                                label="Security Cost Account No."
                                value={dialogRowData.subDivSecurityAccountNo}
                            />
                        </DetailSection>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={showChangePasswordPopup}
                onClose={closeBankDetailsPopup}
                fullWidth
                maxWidth="sm"
                className="alert-popups org-details-dialog org-details-dialog--form"
                aria-labelledby="subdivision-bank-details-dialog-title"
            >
                <DialogTitle
                    id="subdivision-bank-details-dialog-title"
                    component="div"
                    className="dialog-title"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <span className="org-details-dialog__title-text">SubDivision Bank Details</span>
                    <IconButton
                        id="clearPopup"
                        onClick={closeBankDetailsPopup}
                        size="small"
                        aria-label="Close bank details"
                        className="org-details-dialog__close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className="dialog-content">
                    <form className="org-details-dialog__form" onSubmit={bankdetailsFormik.handleSubmit}>
                        <div className="org-details-dialog__form-grid">
                            <div className="org-details-dialog__form-field org-details-dialog__form-field--full">
                                <label className="org-details-dialog__form-label">SubDivision Code</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    value={selectedUserId || ''}
                                    disabled
                                    autoComplete="off"
                                />
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">ERP Code</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_subDivisionERPCode"
                                    value={bankdetailsFormik.values.iv_subDivisionERPCode}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_subDivisionERPCode"
                                />
                                {bankdetailsFormik.errors.iv_subDivisionERPCode && bankdetailsFormik.touched.iv_subDivisionERPCode ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_subDivisionERPCode}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">Bank Name</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_subDivBankName"
                                    value={bankdetailsFormik.values.iv_subDivBankName}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_subDivBankName"
                                />
                                {bankdetailsFormik.errors.iv_subDivBankName && bankdetailsFormik.touched.iv_subDivBankName ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_subDivBankName}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">Capital Cost Account No.</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_subDivCapitalCostAccountNo"
                                    value={bankdetailsFormik.values.iv_subDivCapitalCostAccountNo}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_subDivCapitalCostAccountNo"
                                />
                                {bankdetailsFormik.errors.iv_subDivCapitalCostAccountNo && bankdetailsFormik.touched.iv_subDivCapitalCostAccountNo ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_subDivCapitalCostAccountNo}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field">
                                <label className="org-details-dialog__form-label">Security Account No.</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_subDivSecurityAccountNo"
                                    value={bankdetailsFormik.values.iv_subDivSecurityAccountNo}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_subDivSecurityAccountNo"
                                />
                                {bankdetailsFormik.errors.iv_subDivSecurityAccountNo && bankdetailsFormik.touched.iv_subDivSecurityAccountNo ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_subDivSecurityAccountNo}</p>
                                ) : null}
                            </div>
                            <div className="org-details-dialog__form-field org-details-dialog__form-field--full">
                                <label className="org-details-dialog__form-label">Remarks</label>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required
                                    type="text"
                                    autoComplete="off"
                                    name="iv_remarks"
                                    value={bankdetailsFormik.values.iv_remarks}
                                    onChange={bankdetailsFormik.handleChange}
                                    onBlur={bankdetailsFormik.handleBlur}
                                    id="iv_remarks"
                                />
                                {bankdetailsFormik.errors.iv_remarks && bankdetailsFormik.touched.iv_remarks ? (
                                    <p className="org-details-dialog__form-error">{bankdetailsFormik.errors.iv_remarks}</p>
                                ) : null}
                            </div>
                            {apiError ? (
                                <div className="org-details-dialog__form-field org-details-dialog__form-field--full">
                                    <Error
                                        error={apiError}
                                        onClose={() => errorCloses()}
                                        backgroundColor="#FFC0CB"
                                        textColor="#bb0303"
                                        iconColor="#bb0303"
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div className="org-details-dialog__form-actions">
                            <Button
                                type="submit"
                                variant="contained"
                                size="medium"
                                className="org-details-dialog__submit-btn"
                            >
                                Submit
                            </Button>
                        </div>
                    </form>
                </DialogContent>
            </Dialog>

            <Snackbar
                open={showSuccessSnackbar}
                autoHideDuration={3000}
                onClose={() => setShowSuccessSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            >
                <Alert
                    onClose={() => setShowSuccessSnackbar(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Bank Details Saved.
                </Alert>
            </Snackbar>
            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >

        </>
    )
}
